'use client';
import ScrollHelperBlackTrans from '@lib/tools/helpers/ScrollHelperBlackTrans';

import style from './error.module.scss';

export default function ErrorPage({ reset }) {
  return (
    <>
      <div className={style.wrapper}>
        <div className={style.content}>
          <h1 className={style.content__title}>Ошибка 502</h1>
          <div className={style.content__description}>Упс, сервер не доступен, пожалуйста, перезагрузите страницу.</div>
          <button className={style.content__reloadButton} onClick={reset}>
            Перезагрузить
          </button>
        </div>
      </div>
      <ScrollHelperBlackTrans />
    </>
  );
}
